export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11140.a6654f53.jpg";